import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0045379e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "boardViewPopup",
  class: "popup-vue"
}
const _hoisted_2 = { class: "sub-title mb40" }
const _hoisted_3 = { class: "title-lang" }
const _hoisted_4 = { class: "created-date" }
const _hoisted_5 = { class: "input-item mb30" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "hidden",
  for: "viewTitle"
}, "제목", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "key-title mb20" }, "내용", -1))
const _hoisted_8 = { class: "view-editor" }
const _hoisted_9 = { class: "modify-button-vue" }

import { onBeforeMount, watch } from 'vue';
import { useStore } from 'vuex';
import { computed, ref } from '@vue/reactivity';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import ModifyButton from '@/components/button/ModifyButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BoardViewPopup',
  props: {
  itemSid: {
    type: Number,
    rquired: true,
  },
  boardCode: {
    type: Object,
    required: true,
    boardCategory: {
      type: String,
      required: true,
    },
    boardType: {
      type: String,
      required: true,
    },
  },
},
  emits: ['closeCurrentPopup'],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const Cs = store.state.moduleCs;


/**** data -------------------- */
var title = ref({
  category: ``,
  type: ``,
  lang: ``,
});
var viewTitle = ref('');
var viewContent = ref('');
var currentItem = computed(() => Cs.currentItem);
var createdDate = ref('');
var editor = ref({
  content: '',
  options: {
    placeholder: '내용을 입력해 주세요.',
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ['clean'],
        ['link', 'image', 'video'],
      ],
    },
  },
});
var board = ref({
  itemSid: props.itemSid,
  boardCategory: props.boardCode.boardCategory,
  email: '',
  phone: '',
  boardType: props.boardCode.boardType,
  writerType: '00', // 00:관리자, 01:의사, 02환자
  content: '',
  extra1: '',
  extra2: '',
  extra3: '',
  extra4: '',
  title: '',
});
/**** methods ----------------- */
const onClick_cancel = () => {
  emit('closeCurrentPopup');
};
const onClick_modify = async () => {
  board.value.content = await viewContent.value;
  board.value.title = await viewTitle.value;
  await store.dispatch('moduleCs/modifyBoardItem', board.value, { root: true });
  emit('closeCurrentPopup');
};
const setBoardItem = async () => {
  await store.dispatch('moduleCs/getBoardItem', props.itemSid, { root: true });
  viewTitle.value = await currentItem.value.title;
  viewContent.value = await currentItem.value.content;
};
const setTitle = async () => {
  let cateDoc = [`002`, `102`, `202`, `012`, `112`, `212`];
  let catePt = [`003`, `103`, `203`, `013`, `113`, `213`];
  let langKr = [`001`, `002`, `003`, `011`, `012`, `013`];
  let langEn = [`101`, `102`, `103`, `111`, `112`, `113`];
  let langRu = [`201`, `202`, `203`, `211`, `212`, '213'];
  let typeNotice = `000`;
  let typeFAQ = `001`;
  if (cateDoc.indexOf(props.boardCode.boardCategory) !== -1) {
    title.value.category = `의료진`;
  } else if (catePt.indexOf(props.boardCode.boardCategory) !== -1) {
    title.value.category = `환자`;
  }
  if (typeNotice === props.boardCode.boardType) {
    title.value.type = `공지사항`;
  } else if (typeFAQ === props.boardCode.boardType) {
    title.value.type = `FAQ`;
  }
  if (langKr.indexOf(props.boardCode.boardCategory) !== -1) {
    title.value.lang = `한국어`;
  } else if (langEn.indexOf(props.boardCode.boardCategory) !== -1) {
    title.value.lang = `영어`;
  } else if (langRu.indexOf(props.boardCode.boardCategory) !== -1) {
    title.value.lang = `러시아어`;
  }
  return;
};
/**** content -----------------
 *
 * 게시판 글 상세 조회 팝업
 * /
 * /
/**** hook -------------------- */
onBeforeMount(() => {
  setTitle();
  setBoardItem();
});
watch(
  () => currentItem.value,
  (newValue, oldValue) => {
    if (newValue !== undefined) {
      return (createdDate.value = newValue.createdDate);
    } else if (newValue === `kr`) {
      return (createdDate.value = '-');
    }
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(title).category) + " " + _toDisplayString(_unref(title).type) + " 수정 ", 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(title).lang), 1),
      _createElementVNode("span", _hoisted_4, "[ 최초 작성일: " + _toDisplayString(_unref(createdDate)) + " ]", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "viewTitle",
        id: "viewTitle",
        placeholder: "제목",
        minlength: "1",
        maxlength: "100",
        required: "true",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(viewTitle) ? (viewTitle).value = $event : viewTitle = $event))
      }, null, 512), [
        [_vModelText, _unref(viewTitle)]
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_unref(QuillEditor), {
        class: "quill-editor",
        ref: "postEditor",
        content: _unref(viewContent),
        "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => (_isRef(viewContent) ? (viewContent).value = $event : viewContent = $event)),
        contentType: "html",
        disabled: false,
        value: _unref(editor).content,
        options: _unref(editor).options
      }, null, 8, ["content", "value", "options"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(ModifyButton, {
        onOnClick_cancel: _cache[2] || (_cache[2] = ($event: any) => (onClick_cancel())),
        onOnClick_modify: _cache[3] || (_cache[3] = ($event: any) => (onClick_modify()))
      })
    ])
  ]))
}
}

})